import { render, staticRenderFns } from "./ProductDrawer.vue?vue&type=template&id=647a28d8&scoped=true"
import script from "./ProductDrawer.vue?vue&type=script&lang=js"
export * from "./ProductDrawer.vue?vue&type=script&lang=js"
import style0 from "./ProductDrawer.vue?vue&type=style&index=0&id=647a28d8&prod&lang=scss&scoped=true"
import style1 from "./ProductDrawer.vue?vue&type=style&index=1&id=647a28d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647a28d8",
  null
  
)

export default component.exports